// controls/NoLocationsCard.tsx
import { Card, Box, Typography } from "@mui/material";

const NoLocationsCard = () => {
  return (
    <Card
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 3,
        backgroundColor: "#f8fafc",
        border: "1.5px dashed #cbd5e1",
        boxShadow: 0,
      }}
    >
      <Box textAlign="center" maxWidth={260}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No Hosting Locations
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
          Click Add Location to create a hosting location and begin hosting Pappa Squat users.
        </Typography>
      </Box>
    </Card>
  );
};

export default NoLocationsCard;
